import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, 
    ScrollView, TouchableHighlight } from 'react-native'
import Checkbox from 'expo-checkbox';
import { RadioButton } from 'react-native-paper';
import AppTheme from "../../AppTheme";
import { familyTypes, typeOfProblems } from '../../utils/constants/acs/prePurcaseAayuData';
import { store } from '../../store/store';
import { addFontFamilylato, addFontFamilyStyle } from '../../utils/services/CommonUtils';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';


const AayuCardQuiz = (props) => {

    const [questionType, updateQuestionType] = useState('familyType');

    const [enableButton, updateButtonStatus] = useState({
        nextButton: false,
        submitButton: false
    })

    const [aayuCardPreference, updatPreference] = useState({
        familyType: -1,
        familyProblems: [-1],
    });

    const [aayuCard, updateAayuCard] = useState({
        plans: [{}]
    })

    function checkQuestionType(questionType) {
        if (questionType == 'familyType')
            return true;
        else if (questionType == 'familyProblems')
            return false;
    }

    function checkRadioOption(index) {
        if (index == aayuCardPreference.familyType) return 'checked'
        else return 'unchecked';
    }

    function checkCheckBoxOption(index) {
        return aayuCardPreference.familyProblems.indexOf(index) != -1;
    }

    function checkSubmitButton(questionType) {
        if (questionType == 'familyType')
            return true;
        else if (questionType == 'familyProblems')
            return false;
        else null
    }

    function onRadioOptionSelected(index) {
        updatPreference({
            familyType: index,
            familyProblems: [],
        }); updateButtonStatus({
            nextButton: true,
            submitButton: false,
        })
    }

    function onCheckBoxOptionSelected(index, problemList = aayuCardPreference.familyProblems) {
        
        if (problemList.indexOf(index) == -1) {
            problemList.push(index);
            updateButtonStatus({
                nextButton: false,
                submitButton: true,
            });
        } else if (aayuCardPreference.familyProblems.length > 0) {
            problemList =  problemList.filter(function(item) {
                return item !== index
            })
            updatPreference({
                familyType: aayuCardPreference.familyType,
                familyProblems: problemList
            }); updateButtonStatus({
                nextButton: false,
                submitButton: problemList.length > 0 ?  true : false,
            });
        }
    }

    function onNextButton() {
        if (questionType == 'familyType') {
            if (aayuCardPreference.familyType != -1)
                updateQuestionType('familyProblems');
        }
        else if (questionType == 'familyProblems')
            updateQuestionType('quizComplete');
    }

    useEffect(() => {
        const reduxState = store.getState();
        if (aayuCard.plans.length < 2) updateAayuCard({ plans: reduxState.aayuPlans })
    });

    return (
        <View>
            <View style={{ position: 'fixed', zIndex: 10, backgroundColor: 'white', width: AppTheme.appWidth }}>
                <CommonHeader navigation={props.navigation} title='Plan Recommendation'></CommonHeader>
            </View>

            <ScrollView style={{ margin: 16, marginTop: AppTheme.headerHeight }}>
                <Text style={styles.planRecText}>
                    Answer 2 simple questions to find the best plan for your family</Text>
                {
                    checkQuestionType(questionType) ?
                        <View>
                            <View style={styles.quesContainer}>
                                <Text style={[styles.question, { paddingRight: 5 }]}>1.</Text>
                                <Text style={styles.question}>How big is your family? Choose one.
                        </Text>
                            </View>
                            <View style={{ marginTop: 16 }}>

                                {familyTypes.map((item, index) =>
                                    <Text key={index}  style={styles.radioBtn}>
                                        <RadioButton onPress={() => { onRadioOptionSelected(index) }}
                                            style={{ fontSize: 14, width: 15, height: 15, background: AppTheme.color.primary }}
                                            value={item.value} color={AppTheme.color.primary}
                                            status={checkRadioOption(index)}
                                        />
                                        <Text onPress={() => { onRadioOptionSelected(index) }} style={styles.radioLabel}>{item.label}</Text>
                                    </Text>
                                )}
                            </View>
                        </View> : <View style={{ marginTop: 16 }}>
                            <View style={styles.quesContainer}>
                                <Text style={[styles.question, { paddingRight: 5 }]}>2.</Text>
                                <Text style={styles.question}>What problems are you worried about?
                        <Text style={{ fontSize: 10, color: '#5f5f5f' }}> ( Multiple options can be selected )</Text>
                                </Text>
                            </View>
                            <Text style={{ marginTop: 16 }}>
                                {typeOfProblems.map((problem, index) =>
                                    <Text onPress={() => onCheckBoxOptionSelected(index)} key={index}>
                                        <View style={styles.checkboxContainer} key={index}>
                                            <Checkbox
                                                value={aayuCardPreference.familyProblems.includes(index)}
                                                style={styles.checkbox}
                                                color={checkCheckBoxOption(index) ? AppTheme.color.primary : undefined} />
                                            <Text  style={styles.checkText}>
                                                <Text>{problem.title} </Text>
                                                <Text style={styles.subTitle}>{problem.subTitle}</Text>
                                            </Text>
                                        </View>
                                    </Text>
                                )}
                            </Text>
                        </View>
                }

                {
                    checkSubmitButton(questionType) ?
                        <TouchableHighlight
                            style={[styles.submit, { backgroundColor: enableButton.nextButton ? AppTheme.color.primary : AppTheme.color.grey.disable }]}
                            onPress={() => { onNextButton() }}
                            disabled={!enableButton.nextButton}
                            underlayColor='#fff'>
                            <Text style={styles.submitText}>NEXT</Text>
                        </TouchableHighlight> : <TouchableHighlight
                            style={[styles.submit, { backgroundColor: enableButton.submitButton ? AppTheme.color.primary : AppTheme.color.grey.disable }]}
                            onPress={() => {
                                props.navigation.replace(ScreenRoute.acs_plan_recommender, { aayuPreferences: aayuCardPreference, aayuPlans: aayuCard.plans })
                            }}
                            disabled={!enableButton.submitButton}
                            underlayColor='#fff'>
                            <Text style={styles.submitText}>SUBMIT</Text>
                        </TouchableHighlight>
                }

            </ScrollView>

        </View>
    )
}

export default AayuCardQuiz;

const styles = StyleSheet.create(addFontFamilylato({
    checkText: { marginTop: 8, paddingLeft: 9, paddingRight: 12 },
    radioLabel: { fontSize: 14, position: 'relative', left: 10, bottom: 5 },
    planRecText: { color: AppTheme.color.grey.text, fontSize: 10, marginTop: 16 },
    radioBtn: {
        paddingLeft: 6,
        alignItems: 'center',
        flexDirection: 'row',
        // marginBottom: 16,
        backgroundColor: 'white',
        // height: 55,
        elevation: 1,
        borderRadius: 4,
        fontSize: 14
    },
    question: { fontSize: 14, color: '#333333', marginTop: 16 },
    quesContainer: {
        flex: 1,
        justifyContent: "flex-start",
        flexDirection: 'row'
    },
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    checkboxContainer: {
        // flexDirection: "row",
        fontSize: 14, flex: 1, flexDirection: 'row',
        alignItems: 'flex-start', alignContent: 'flex-start',
    },
    checkbox: {
        // alignSelf: "center",
        margin: 10
    },
    submit: {
        margin: 'auto', paddingVertical: 6,
        borderRadius: 4, color: '#ffffff',
        // borderColor: AppTheme.color.primary,
        width: 180,
        alignItems: "center",
        marginTop: 25
    },
    submitText: {
        color: '#fff',
        textAlign: 'center',
        fontWeight: '900',
        fontSize: 18,
    },
    subTitle: {
        fontSize: 12, color: AppTheme.color.grey.text, flex: 1, flexWrap: 'wrap',
        justifyContent: 'flex-start', alignContent: 'flex-start'
    }
}))